import { render, staticRenderFns } from "./GuidanceInfoModal.vue?vue&type=template&id=ed744f32&scoped=true&"
import script from "./GuidanceInfoModal.vue?vue&type=script&lang=ts&"
export * from "./GuidanceInfoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed744f32",
  null
  
)

export default component.exports